import React from 'react';
export const UrgencyBar = () => {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-[#ADFF2F]/20 text-xs sm:text-sm py-2.5 px-4 shadow-lg" data-id="element-289">
      <div className="container mx-auto flex items-center justify-center text-center" data-id="element-290">
        <span className="text-[#ADFF2F] font-bold" data-id="element-291">
          ⚡ Descarga inmediata disponible ahora
        </span>
      </div>
    </div>;
};